import React from "react";
import { DateRangerPicker } from "staysure-component-library";
import { LocaleType } from "staysure-component-library/dist/types/commonTypes";

import { getDateLocaleCode } from "@/libs/i18n/config";
import { useWizardTranslation } from "@/libs/i18n/use-wizard-translation";
import { useCurrentLocale } from "@/libs/i18n/utils.client";

import { useDateSelectionST } from "./date-range-picker.hooks";
import { useTravelDatesContext } from "../../providers/travel-dates.provider";
import { DateRange } from "../../types/travel-dates.type";

function DateRangePickerComponent() {
  const { handleDateSelectionST, handleDateTypingST } = useDateSelectionST();
  const context = useTravelDatesContext();

  const {
    cancelBtnClick,
    isDateError,
    isMobile,
    maxDateForReturnST,
    travelDateErrorMessage,
    travelDates,
  } = context;

  const locale = useCurrentLocale();

  const t = useWizardTranslation().t;

  return (
    <div>
      <DateRangerPicker
        isScroolTop
        onErrorMessage={() => {}}
        defaultDate={
          travelDates.startDate && travelDates.endDate
            ? [travelDates.startDate, travelDates.endDate]
            : undefined
        }
        calendarType="type1"
        dateRangeMaxLimit={maxDateForReturnST}
        onChange={(date: DateRange<unknown>) => {
          handleDateSelectionST(date as Date[]);
        }}
        onChangeDateTyping={(date: DateRange<unknown>) => {
          handleDateTypingST(date as Date[]);
        }}
        customizedErrorMessage={travelDateErrorMessage}
        isError={isDateError}
        isDateClear={cancelBtnClick}
        isReadOnly={isMobile}
        locale={getDateLocaleCode(locale) as LocaleType}
        startEndDatesText={{
          startDateText: t("from"),
          endDateText: t("until"),
        }}
      />
    </div>
  );
}

export default DateRangePickerComponent;
